import { infrastructuresRepo } from '@/constants/providers';
import { CompanyKeys } from '@/modules/Companies/queries';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { InfrastructureCostKey } from './types';

export const useDeleteInfrastructureCost = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => infrastructuresRepo.deleteById(id),
    onError: () => {
      toast.error(t('error.delete_infrastructure_cost'));
    },
    onSuccess: () => {
      toast.success(t('success_delete_infrastructure_cost'));
      queryClient.invalidateQueries(InfrastructureCostKey.ALL);
      queryClient.invalidateQueries(CompanyKeys.ALL);
      queryClient.invalidateQueries(OrganizationKeys.ALL);
    },
  });
};
